// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__os-9r","back":"App_back__AbE+D","loaderContainer":"App_loaderContainer__z9WEs"};